const { Parser } = require('json2csv');
const FileSaver = require('file-saver');
const moment = require('moment');

angular
  .module("AccountingBoxApp")
  .controller("BookkeeperCompaniesCtrl", function(
    $scope,
    $rootScope,
    $location,
    $filter,
    $stateParams,
    $state,
    $interval,
    $cachedResource,
    Company,
    $window
  ) {
    $window.document.title = 'Bedrijven - AdministratieBox';

    //  var table = $('#dataTable');
    $scope.order = {
      by: ['oldestUnprocessedDocumentDate','-inboxCount','name'],
      reverse: false,
      filter: ""
    };
    var propsPrefix = "AB-";

    var vm = this;
    vm.filter = "active";
    vm.getCompanies = getCompanies;


    $rootScope.getBookkeepers().then((bookkeepers)=> {
      console.log('bookkeepers',bookkeepers);
      vm.bookkeepers = bookkeepers
    })

    vm.userFilter = null


    vm.currentBookkeepers = function(slug) {
      return Object.values($rootScope.users).filter((b)=> b.currentCompanySlug === slug).map((b)=>b.name.split(' ').map(e=>e[0]).join('').toUpperCase()).join(", ");
    }

    //clear cache
    _.forIn(window.localStorage, function(value, objKey) {
      if (objKey.startsWith("cachedResource://")) {
        window.localStorage.removeItem(objKey);
      }
    });

    /* vm.companies = Company.find({
            filter: {
                include: 'users'
            }
        });*/
    //var stop;

    function getCompanies() {
      var toReturn = vm.companies;
      if(toReturn && toReturn.length > 0) {
        toReturn = toReturn.map(c => {
          c.contactName = c.contactName || c.users && c.users[0] && c.users[0].name;
          return c
        })
        // || c.users[0].name
        if (vm.filter === "active") {
          toReturn = _.filter(toReturn, function(c) {
            return c.customerNumber && (!c.endDate || moment(c.endDate).isAfter(moment())) && !c.blocked;
          });
        }
        if (vm.filter === "paused") {
          toReturn = _.filter(toReturn, function(c) {
            return c.customerNumber && (!c.endDate || (c.endDate && moment(c.endDate).isAfter(moment()))) && c.blocked;
          });
        }
        if (vm.filter === "ended") {
          toReturn = _.filter(toReturn, function(c) {
            return c.customerNumber && moment(c.endDate).isBefore(moment()) && !c.blocked;
          });
        }
        else if (vm.filter === "trial") {
          toReturn = _.filter(toReturn, { demo: true, blocked: false });
        }
        else if (vm.filter === "blocked") {
          toReturn = _.filter(toReturn, { blocked: true });
        }

        if(vm.userFilter) {
          toReturn = toReturn.filter((c)=> {
            return c.bookkeeperId === vm.userFilter.id || c.taxAdvisorId === vm.userFilter.id
          })
        }
      }
      //  console.log('get companies:',vm.filter);
      return toReturn;
    }

    // Function to replicate setInterval using $timeout service.
    /*$scope.intervalFunction = function(){
          $timeout(function() {
              console.log('function .....');
           Company.find({filter:{
                  include: 'users'
              }},function (cs) {
              companies = cs;
              vm.companies = companies;
              $scope.intervalFunction();
              });
          }, 15000);
        };*/

    /*  var refreshData = function() {
    // Assign to scope within callback to avoid data flickering on screen
    Data.query({ someField: $scope.fieldValue }, function(dataElements){
        $scope.data = dataElements;
    });
};*/

    vm.loading = false;
    vm.refreshData = function() {
      vm.loading = true;
      Company.customFind({
        filter: {
          include: ["users", "bookkeeper", "taxAdvisor"]
        }
      }).$promise.then(function(companies) {
        vm.loading = false;
        vm.companies = companies;
        save(localStorage, "companies", vm.companies);
      });
    };
    vm.companies = load("companies") || [];
    // if(c.length>0){
    //     vm.companies=c;
    // }else{
    //     vm.refreshData();
    // }
    vm.refreshData();
    const visibilitychange = function() {
      if (document.hidden) {
      } else {
        vm.refreshData();
      }
    }
    window.addEventListener("visibilitychange", visibilitychange);
    $scope.$on('$destroy', function() {
      window.removeEventListener("visibilitychange", visibilitychange);
    });



    vm.activate = function(company) {
      Company.activate({ id: company.id }).$promise.then(function() {
        vm.refreshData();
      });
    };

    vm.deactivate = function(company) {
      Company.deactivate({ id: company.id }).$promise.then(function() {
        vm.refreshData();
      });
    };

    //  var stop = $interval(function(){
    //   //  console.log('interval');
    //     vm.refreshData();
    //  }, 5*60*1000);

    // Cancel interval on page changes
    // $scope.$on('$destroy', function() {
    //         //if (angular.isDefined(stop)) {
    //             $interval.cancel(stop);
    //           //  stop = undefined;
    //         //}
    //     });

    // vm.refreshData();

    // Kick off the interval
    // $scope.intervalFunction();
    // _.isEqual(companies, array2);

    // vm.companies = companies;

    vm.goToInbox = function(company) {
      // $cachedResource.clearCache({exceptFor:['Companies', 'Accounts','VatCodes']});
      $state.go("app.company.inbox", {
        id: company.id,
        companySlug: company.slug
      });
    };
    vm.goToBankAccounts = function(company) {
      $state.go("app.company.bank.accounts", {
        id: company.id,
        companySlug: company.slug
      });
      // let url = $state.href('app.company.bank.accounts', {
      //   id: company.id,
      //   companySlug: company.slug
      // });
      // $window.open(url,'_blank');
    };
    vm.editCompany = function(company) {
      $scope.$broadcast("editCompany", company);
      $("#companyModal").modal("show");
    };

    $scope.$on("companySaved", function(e, company) {
      console.log("companySaved");
      $("#companyModal").modal("hide");
      Company.customFind({
        filter: {
          include: "users"
        }
      }).$promise.then(function(companies) {
        vm.companies = companies;
      });
    });

    vm.newContact = function() {
      $state.go("app.company.contact.new");
    };

    function save(storage, name, value) {
      var key = propsPrefix + name;
      if (value === null) value = "";
      storage[key] = JSON.stringify(value);
    }

    function load(name) {
      var key = propsPrefix + name;
      return localStorage[key]? JSON.parse(localStorage[key]) : null;
    }

    vm.totalSum = function(key) {
      return $filter('filter')(vm.getCompanies(), $scope.order.filter).reduce((a, b) => a + b[key] || 0, 0)
    }


    vm.download = function() {
      let companies =  $filter('orderBy')($filter('filter')(vm.getCompanies(), $scope.order.filter), $scope.order.by, $scope.order.reverse)

      console.log('companies',companies)

      companies = companies.map(c => {
        c.language = "nl"
        return c;
      })

      let fields = [
        {
          label: 'Klantnummer',
          value: 'customerNumber'
        },
        {
        label: 'Bedrijfsnaam',
        value: 'name'
      },
      {
        label: 'Contactpersoon',
        value: 'users[0].name'
      },
      {
        label: 'Voornaam',
        value: 'users[0].firstName'
      },
      {
        label: 'E-mail',
        value: 'users[0].email'
      },
      {
        label: 'Telefoon',
        value: 'phone'
      },
      {
        label: 'Website',
        value: 'website'
      },
      {
        label: 'Uniek e-mailadres',
        value: 'uniqueEmailAddress'
      },
      {
        label: 'Slug',
        value: 'slug'
      },
        {
          label: 'Bedrijfsactiviteit',
          value: 'companyActivity'
        },
      {
        label: 'KvK nummer',
        value: 'companyRegistrationNumber'
      },
        {
          label: 'Oprichtingsdatum',
          value: 'foundationDate'
        },
      {
        label: 'BTW nummer',
        value: 'vatIdentificationNumber'
      },
      {
        label: 'BTW aangiftetijdvak',
        value: 'vatPeriod'
      },
      {
        label: 'Straat',
        value: 'address.line1'
      },
      {
        label: 'Postcode',
        value: 'address.postalCode'
      },
      {
        label: 'Plaats',
        value: 'address.city'
      },
      {
        label: 'Land',
        value: 'address.country'
      },
      {
        label: 'Taal',
        value: 'language'
      },
      {
        label: 'Rechtsvorm',
        value: 'businessType'
      },
        {
          label: 'Registratiedatum',
          value: 'registrationDate'
        },
      {
        label: 'Startdatum',
        value: 'startDate'
      },
        {
          label: 'Einddatum',
          value: 'endDate'
        },
      {
        label: 'Werknemers',
        value: 'numberOfEmployees'
      },
        {
          label: 'Aantal IB-aangiften',
          value: 'numberOfIncomeTaxReturns'
        },
        {
          label: 'OSS-aangifte',
          value: 'oneStopShopReturn'
        },
        {
          label: 'Gratis',
          value: 'demo'
        },
        {
          label: 'Geblokkeerd',
          value: 'blocked'
        },
        {
          label: 'Inbox',
          value: 'inboxCount'
        },
        {
          label: 'Onverwerkte banktransacties',
          value: 'bankTransactionCount'
        },
        {
          label: 'Boekhouder',
          value: 'bookkeeper.name'
        },
        {
          label: 'Fiscaal Adviseur',
          value: 'taxAdvisor.name'
        },
      {
        label: 'Id',
        value: 'id'
      },
      ];

      if($rootScope.isAdmin()) {
        fields = fields.concat([
          {
            label: 'Max banktransacties per kwartaal',
            value: 'maximumBankTransactionsPerQuarter'
          },
          {
            label: 'Prijsmodel',
            value: 'pricingModel'
          },
          {
            label: 'Standaard abonnementstarief',
            value: 'baseSubscriptionPrice'
          },
          {
            label: 'Totaal abonnementstarief',
            value: 'monthlySubscriptionPrice'
          },
          {
            label: 'Automatisch factureren',
            value: 'autoBilling'
          }
        ])
      }

      const json2csvParser = new Parser({ fields });
      const csv = json2csvParser.parse(companies);
      var blob = new Blob([csv], {type: "text/csv;charset=utf-8"});
      FileSaver.saveAs(blob, `AB-bedrijven-overzicht-${moment().format('YYYY-MM-DD')}`);

      console.log(csv);
    }
    vm.focussedIndex = -1
    vm.filteredCompanies = []
    vm.onKeyDown = function(e) {
      // console.log('ng-keydown', e.keyCode)
      if (e.keyCode == '38') {
        vm.focussedIndex -= 1
      } else if (e.keyCode == '40') {
        vm.focussedIndex += 1
      }else if (e.keyCode == '13') {
        vm.goToInbox(vm.filteredCompanies[vm.focussedIndex])
      }else {
        vm.focussedIndex = 0
      }
      vm.focussedIndex = Math.max(0, Math.min(vm.focussedIndex, vm.filteredCompanies.length-1))
      // if($scope.order.filter.length==0){
      //   vm.focussedIndex = -1
      // }
    }

    //
    // function dotheneedful(sibling) {
    //   if (sibling != null) {
    //     start.focus();
    //     start.style.backgroundColor = '';
    //     start.style.color = '';
    //     sibling.focus();
    //     sibling.style.backgroundColor = 'green';
    //     sibling.style.color = 'white';
    //     start = sibling;
    //   }
    // }

    // document.onkeydown = checkKey;
    //
    // function checkKey(e) {
    //   e = e || window.event;
    //   if (e.keyCode == '38') {
    //     // up arrow
    //     var idx = start.cellIndex;
    //     var nextrow = start.parentElement.previousElementSibling;
    //     if (nextrow != null) {
    //       var sibling = nextrow.cells[idx];
    //       dotheneedful(sibling);
    //     }
    //   } else if (e.keyCode == '40') {
    //     // down arrow
    //     var idx = start.cellIndex;
    //     var nextrow = start.parentElement.nextElementSibling;
    //     if (nextrow != null) {
    //       var sibling = nextrow.cells[idx];
    //       dotheneedful(sibling);
    //     }
    //   } else if (e.keyCode == '37') {
    //     // left arrow
    //     var sibling = start.previousElementSibling;
    //     dotheneedful(sibling);
    //   } else if (e.keyCode == '39') {
    //     // right arrow
    //     var sibling = start.nextElementSibling;
    //     dotheneedful(sibling);
    //   }
    // }


  });
